import { Box } from "@mui/material";
import styled from "styled-components";

import { colors } from "components";

interface IBodyDrawer {
  paddingLeft?: number;
  paddingRight?: number;
  paddingTop?: number;
  paddingBottom?: number;
  height?: string | number;
}

export const Body = styled.div<IBodyDrawer>`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  scrollbar-gutter: stable;
  background-color: ${colors.default_base_white};

  padding-left: ${(props) =>
    typeof props.paddingLeft === "number" ? props.paddingLeft + "px" : "50px"};
  padding-right: ${(props) =>
    typeof props.paddingRight === "number"
      ? props.paddingRight + "px"
      : "50px"};
  padding-top: ${(props) =>
    typeof props.paddingTop === "number" ? props.paddingTop + "px" : "20px"};
  padding-bottom: ${(props) =>
    typeof props.paddingBottom === "number" ? props.paddingBottom + "px" : "20px"};
`;

export const DrawerForm = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ContainerFooter = styled(Box)`
  width: 100%;
  height: 95px;
  flex-shrink: 0;
  background-color: ${colors.background_primary};
  bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  margin-top: auto;
`;

export const DivFooter = styled(Box)`
  width: 80px;
  padding: 0px, 16px, 0px, 16px;
  margin-right: 14px;
`;

export const ContainerTwoComponents = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;
  margin-left: -95px;
`;
